/**
 * Testi italiani dell'account GitHub di institor (ADR 0014): connessione di
 * piattaforma, repository creato per un progetto senza GitHub suo, spostamento
 * del repository su un account dell'utente.
 */

/** Testi dell'account GitHub di institor. */
export const githubManaged = {
  /** Sezione della pagina Strumenti, solo per chi amministra la piattaforma. */
  platform: {
    /** Titolo. */
    title: 'Account GitHub di institor',
    /** Che cosa fa. */
    intro:
      'I progetti che non collegano un repository GitHub loro ne ricevono uno nuovo su questo account, creato al primo avvio di un set. Gli agenti scrivono solo nel repository del loro progetto.',
    /** Pulsante di collegamento e titolo del cassetto. */
    connect: 'Collega l’account di institor',
    /** Nessuna connessione. */
    empty: 'Nessun account collegato. I progetti senza un repository loro non hanno GitHub.',
    /** Lettura non riuscita. */
    loadFailed: 'Caricamento dell’account di institor non riuscito. Riprova.',
    /** Titolo delle opzioni. */
    options: 'Opzioni dei repository creati',
    /** Etichetta dell'organizzazione. */
    organization: 'Organizzazione',
    /** Aiuto. */
    organizationHelp: 'Facoltativa: il nome dell’organizzazione GitHub in cui creare i repository. Vuota, li crea l’account del token.',
    /** Valore malformato. */
    organizationInvalid: 'Scrivi il nome dell’organizzazione come su GitHub (lettere, cifre e trattini), oppure lascia vuoto.',
    /** Etichetta della visibilità. */
    visibility: 'Visibilità',
    /** Privato. */
    private: 'Privati',
    /** Pubblico. */
    public: 'Pubblici',
    /** Pulsante di salvataggio. */
    save: 'Salva opzioni',
    /** Esito. */
    saved: 'Opzioni salvate.',
    /** Esito fallito. */
    saveFailed: 'Salvataggio delle opzioni non riuscito. Riprova.',
  },

  /** Blocco della scheda Strumenti di un progetto. */
  managed: {
    /** Titolo. */
    title: 'Repository GitHub di institor',
    /** Che cosa è. */
    intro:
      'Senza un repository GitHub suo, il progetto ne riceve uno sull’account di institor, creato al primo avvio di un set. Puoi spostarlo sul tuo account quando vuoi.',
    /** Il progetto ha un GitHub suo. */
    hasOwn: 'Il progetto usa un repository GitHub suo: quello di institor non serve.',
    /** Nessun repository. */
    none: 'Nessun repository creato. Si crea al primo avvio di un set, o subito con «Crea ora».',
    /** Lettura non riuscita. */
    loadFailed: 'Caricamento del repository di institor non riuscito. Riprova.',
    /** Pulsante di creazione. */
    create: 'Crea ora',
    /** Esito della creazione. */
    created: 'Repository pronto.',
    /** Creazione non riuscita. */
    createFailed: 'Creazione del repository non riuscita. Riprova.',
    /** Etichetta dello stato. */
    stateLabel: 'Stato',
    /** Etichetta del repository. */
    repository: 'Repository',
    /** Stati. */
    state: {
      ready: 'Pronto',
      failed: 'Errore',
      transferring: 'In attesa di accettazione',
      migrated: 'Spostato',
    },
    /** Trasferimento in attesa. */
    transferringHelp:
      'GitHub ha mandato un’email a {{target}} per accettare il trasferimento. Dopo l’accettazione premi «Controlla»: il progetto passa al tuo account. Fino ad allora gli agenti usano il repository di institor.',
    /** Spostato. */
    migratedHelp: 'Il repository è sul tuo account e il progetto lo usa con la tua connessione.',
    /** Pulsante di spostamento. */
    move: 'Sposta sul mio account',
    /** Pulsante di controllo. */
    check: 'Controlla',
    /** Trasferimento non ancora accettato. */
    stillPending: 'Il trasferimento non è ancora stato accettato su GitHub.',
    /** Trasferimento concluso. */
    moved: 'Repository spostato: il progetto usa il tuo account.',
    /** Controllo fatto. */
    checked: 'Stato del trasferimento aggiornato.',
    /** Controllo non riuscito. */
    checkFailed: 'Controllo non riuscito. Riprova.',
    /** Errori con codice. */
    errors: {
      platformMissing: 'L’account GitHub di institor non è ancora collegato: chiedilo a un amministratore.',
      projectHasGithub: 'Il progetto usa già un repository GitHub suo.',
      notReady: 'Il repository di institor non è pronto per lo spostamento.',
      refused: 'GitHub ha rifiutato l’operazione sul repository.',
    },
  },

  /** Cassetto dello spostamento. */
  transfer: {
    /** Introduzione. */
    intro:
      'Il repository passa a un tuo account con il trasferimento di GitHub: storia, rami e issue restano. Verso il tuo account personale GitHub ti manda un’email da accettare; verso un’organizzazione il passaggio può essere immediato.',
    /** Etichetta della connessione. */
    connection: 'La mia connessione GitHub',
    /** Segnaposto. */
    connectionPlaceholder: 'Scegli una connessione',
    /** Nessuna connessione. */
    noConnections: 'Nessuna connessione GitHub tua. Collegala dalla pagina Strumenti.',
    /** Connessione mancante. */
    connectionMissing: 'Scegli una connessione.',
    /** Etichetta del destinatario. */
    owner: 'Account o organizzazione di destinazione',
    /** Aiuto. */
    ownerHelp: 'Facoltativo. Vuoto, il repository va all’account della connessione scelta.',
    /** Destinatario malformato. */
    ownerInvalid: 'Scrivi il nome come su GitHub (lettere, cifre e trattini), oppure lascia vuoto.',
    /** Pulsante. */
    submit: 'Sposta',
    /** Trasferimento chiesto. */
    requested: 'Trasferimento chiesto. Accetta l’email di GitHub, poi premi «Controlla».',
    /** Fallito. */
    failed: 'Spostamento non riuscito. Riprova.',
    /** Negato. */
    forbidden: 'Puoi spostare il repository solo su una connessione tua e se amministri il progetto.',
  },
};

/** Forma dei testi, per le altre lingue. */
export type GithubManaged = typeof githubManaged;
